import { TabMode } from '../../../../event-panel/tabs/components/types';
import { BoloPanelTab, boloPanelTabConfig } from '../../config/bolo-panel-tabs-config';
import { Box } from '@cad-arc';
import { Resizable } from 're-resizable';

export const ActiveBoloTab = ({ activeTab, mode }: { activeTab?: BoloPanelTab; mode: TabMode }) => {
    if (!activeTab) {
        return <></>;
    }
    const TabComponent = boloPanelTabConfig[activeTab].component;

    return mode === 'FULL' ? (
        <Box flexGrow={1000000} w="100%" minHeight={0}>
            {!TabComponent ? undefined : <TabComponent />}
        </Box>
    ) : (
        <Resizable
            enable={{
                top: true,
            }}
            defaultSize={{
                width: '100%',
                height: 300,
            }}
            minHeight={50}
            maxHeight={580}
        >
            <Box
                w="100%"
                h="100%"
                borderTop="sm"
                borderColor="border.default"
            >
                <TabComponent />
            </Box>
        </Resizable>
    );
};
